import { render, staticRenderFns } from "./riskPlayerWhite.vue?vue&type=template&id=568d45ce&scoped=true"
import script from "./riskPlayerWhite.vue?vue&type=script&lang=js"
export * from "./riskPlayerWhite.vue?vue&type=script&lang=js"
import style0 from "./riskPlayerWhite.vue?vue&type=style&index=0&id=568d45ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d45ce",
  null
  
)

export default component.exports